// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
licenceholder-footer footer {
  background: var(--c_mainColorDarkActive);
  padding: 40px 0;
  color: var(--c_textLight);
  min-height: 200px;
  box-sizing: border-box;
}
licenceholder-footer footer visiba-svg {
  width: 20px;
}
licenceholder-footer footer visiba-svg .fill {
  fill: var(--c_textLight);
}
licenceholder-footer footer visiba-svg svg {
  max-height: 40px;
}
licenceholder-footer footer .basicInfo {
  font-weight: lighter;
}
licenceholder-footer footer .basicInfo > .row {
  padding: 2px 0;
}
licenceholder-footer footer .basicInfo .icon {
  float: left;
  position: relative;
}
licenceholder-footer footer .basicInfo .text {
  float: left;
  width: calc(100% - 40px);
  margin-left: var(--m_components);
}
licenceholder-footer footer .basicInfo .text a {
  color: var(--c_textLight);
  -webkit-hyphens: manual;
  hyphens: manual;
  word-break: break-word;
}
licenceholder-footer footer .basicInfo .text a:hover {
  font-weight: normal;
}
licenceholder-footer footer .basicInfo .text.about {
  white-space: pre-line;
}
licenceholder-footer footer .basicInfo .text.about a {
  color: var(--c_mainColorLight);
}
licenceholder-footer footer .logos {
  display: flex;
  flex-direction: column;
  align-items: center;
}
licenceholder-footer footer .logos img.ce {
  margin-top: 80px;
  width: 40px;
  display: inline;
}
licenceholder-footer footer .logos img.visiba {
  margin-top: 20px;
  width: 100px;
  display: inline;
}
@media screen and (max-width: 905px) {
  licenceholder-footer footer .container {
    width: auto;
    margin: 0 1rem;
  }
  licenceholder-footer footer .row > .basicInfo {
    width: 100%;
    margin-left: 0;
    margin-bottom: 1rem;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
